import React from 'react';
import PropTypes from 'prop-types';
import styles from './Icon.scss';

const Icon = function Icon({ size, color, children }) {
    return (
        <span
            className={styles.icon}
            style={{
                fontSize: `${size}px`,
                color,
                width: `${size}px`,
            }}
        >
            {children}
        </span>
    );
};

export { Icon };

export const iconPropTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

Icon.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    children: PropTypes.node.isRequired,
};

Icon.defaultProps = {
    size: 16,
    color: 'inherit',
};
